import { createFileRoute, notFound } from '@tanstack/react-router';

import { createQueryLoader, getServerQueryResponse } from '@/loader';
import DirectoryAgentPageQueryNode, {
  type DirectoryAgentPageQuery,
} from '@/pages/directory/__generated__/DirectoryAgentPageQuery.graphql';
import DirectoryAgentPage from '@/pages/directory/DirectoryAgentPage';
import { getDirectoryTowns } from '@/sanity/directory';
import { getFooterLandingPages } from '@/sanity/landing-page';
import { getLegalLinks } from '@/sanity/legal-document';

const loadDirectoryAgent = createQueryLoader<DirectoryAgentPageQuery>(
  DirectoryAgentPageQueryNode,
  { fetchPolicy: 'store-or-network' },
);

export const Route = createFileRoute('/agents/$agentSlug')({
  loader: async ({ context, params }) => {
    const queryData = await loadDirectoryAgent({
      environment: context.relayEnvironment,
      variables: { agentSlug: params.agentSlug },
    });
    const serverResponse = getServerQueryResponse(queryData);
    const agent = serverResponse?.landlordDirectoryAgent;
    if (serverResponse && !agent) {
      throw notFound();
    }

    const [towns, footerLandingPages, footerLegalLinks] = await Promise.all([
      getDirectoryTowns(),
      getFooterLandingPages(),
      getLegalLinks(),
    ]);

    return {
      footerLandingPages,
      footerLegalLinks,
      queryData,
      towns,
    };
  },
  component: DirectoryAgentPage,
});
